// Generated by genversion.
module.exports = '1.1.2'
